import { create } from 'zustand'

import type { ModelsUserFullInfoResponse } from '@/api/generated-api'
import { isAuthenticated as checkAuth, removeAuthTokens } from '@/utils/auth'

interface AuthState {
  isAuthenticated: boolean
  user: ModelsUserFullInfoResponse | null

  login: () => void
  logout: () => void
  setUser: (user: ModelsUserFullInfoResponse | null) => void
  checkAuth: () => void
}

function readInitialAuthenticated(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  return checkAuth()
}

export const useAuthStore = create<AuthState>(set => ({
  isAuthenticated: readInitialAuthenticated(),
  user: null,

  login: () => {
    set({ isAuthenticated: true })
  },

  logout: () => {
    removeAuthTokens()
    set({ isAuthenticated: false, user: null })
  },

  setUser: user => {
    set({ user })
  },

  checkAuth: () => {
    const authenticated = checkAuth()
    set({ isAuthenticated: authenticated })
  }
}))
